import React from 'react';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';
import { mockData } from './mockData';

const Footer = () => {
  const { company } = mockData;

  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <h4>{company.name}</h4>
            <p className="mb-4">{company.description}</p>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Mail size={16} />
                <a href={`mailto:${company.email}`}>{company.email}</a>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={16} />
                <a href={`tel:${company.phone}`}>{company.phone}</a>
              </div>
              <div className="flex items-start gap-2">
                <MapPin size={16} className="mt-1" />
                <span>{company.address}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <div className="space-y-2">
              <button 
                onClick={() => scrollToSection('#how-it-works')}
                className="block text-left hover:text-white transition-colors"
              >
                How It Works
              </button>
              <button 
                onClick={() => scrollToSection('#services')}
                className="block text-left hover:text-white transition-colors"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('#testimonials')}
                className="block text-left hover:text-white transition-colors"
              >
                Testimonials
              </button>
              <button 
                onClick={() => scrollToSection('#contact')}
                className="block text-left hover:text-white transition-colors"
              >
                Contact
              </button>
            </div>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4>Services</h4>
            <div className="space-y-2">
              <p>AI Voice Automation</p>
              <p>SMS & Email Integration</p>
              <p>Appointment Scheduling</p>
              <p>CRM Management</p>
              <p>Lead Follow-up</p>
              <p>Analytics & Reporting</p>
            </div>
          </div>

          {/* Industries */}
          <div className="footer-section">
            <h4>Industries</h4>
            <div className="space-y-2">
              <p>Healthcare</p>
              <p>Legal Services</p>
              <p>Home Services</p>
              <p>Beauty & Wellness</p>
              <p>Professional Services</p>
              <p>Automotive</p>
            </div>
          </div>

          {/* Resources */}
          <div className="footer-section">
            <h4>Resources</h4>
            <div className="space-y-2">
              <a href="#" className="flex items-center gap-2 hover:text-white transition-colors">
                Case Studies
                <ExternalLink size={14} />
              </a>
              <a href="#" className="flex items-center gap-2 hover:text-white transition-colors">
                Blog
                <ExternalLink size={14} />
              </a>
              <a href="#" className="flex items-center gap-2 hover:text-white transition-colors">
                Documentation
                <ExternalLink size={14} />
              </a>
              <a href="#" className="flex items-center gap-2 hover:text-white transition-colors">
                Support
                <ExternalLink size={14} />
              </a>
            </div>
          </div>

          {/* Get Started */}
          <div className="footer-section">
            <h4>Get Started</h4>
            <p className="mb-4">Ready to automate your business?</p>
            <button 
              onClick={() => scrollToSection('#contact')}
              className="btn-secondary mb-4"
            >
              Schedule Demo
            </button>
            <p className="text-sm">
              30-day money-back guarantee. No setup fees.
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 {company.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;